import { use } from 'react';
import ReviewsContext from './reviews.context';
const useReviewsOrder = () => {
    const { order, setOrder } = use(ReviewsContext);
    return { order, setOrder };
};
export default useReviewsOrder;
